/**
 * Custom replacement for react-intl-redux.
 * Provides intlReducer, updateIntl action creator, and a Redux-connected IntlProvider.
 */
import React from 'react';
import { IntlProvider as BaseIntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';

// Action type
const UPDATE_INTL = '@@intl/UPDATE';

// Default state
const initialState = {
  locale: 'en',
  messages: {},
  formats: {},
};

// Reducer
export const intlReducer = (state = initialState, action) => {
  if (action.type === UPDATE_INTL) {
    return { ...state, ...action.payload };
  }
  return state;
};

// Action creator
export const updateIntl = ({ locale, messages, formats }) => ({
  type: UPDATE_INTL,
  payload: { locale, messages, formats },
});

// Redux-connected IntlProvider
export const IntlProvider = ({ children }) => {
  const { locale, messages, formats } = useSelector((state) => state.intl);

  return (
    <BaseIntlProvider
      locale={locale}
      messages={messages}
      formats={formats}
      defaultLocale="en"
    >
      {children}
    </BaseIntlProvider>
  );
};
